import { c as _c } from "react/compiler-runtime";
import { ProjectsOverviewEmptyPage } from "@components/common/empty-page/projects-overview-empty-page";
import { EntitiesToolbar } from "@components/common/toolbar/entities-toolbar";
import { ProjectsSort } from "@components/projects/projects-sort";
import { BulkChangeProjectStatus } from "@components/table/projects/bulk-actions/bulk-change-project-status";
import { BulkExportProjects } from "@components/table/projects/bulk-actions/bulk-export-projects";
import { ProjectsTable } from "@components/table/projects/projects-table";
import { ColumnPreferencesProvider } from "@context-providers/table/column-preferences-provider";
import { useFetchProjects } from "@hooks/projects/use-fetch-projects";
import { useMediaQueryList } from "@hooks/use-media-query";
import { ProjectsMap } from "@pages/projects/projects-map/projects-map";
import { ProjectsMobileView } from "@pages/projects/projects-mobile-view";
import { ProjectsTiles } from "@pages/projects/projects-tiles";
import { useProjectTableColumnsConfig } from "@pages/projects/projects-utils";
import { useAppSelector } from "@store/store-helper";
import { selectedEntitiesSelector } from "@store/table/table-selector";
import { dataViewModeSelector } from "@store/ui/ui-selector";
import { useMemo } from "react";
import { CreateProjectDialog } from "@pages/projects/create-project-dialog";
/**
 * The projects tab listing all the active or archived projects (depending on the props) in the company
 */
export function ProjectsOverview(t0) {
  const $ = _c(74);
  const {
    companyId,
    projectArchivingState,
    shouldForceLoading
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = selectedEntitiesSelector("projects");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const selectedEntities = useAppSelector(t1);
  const {
    projects: viewMode
  } = useAppSelector(dataViewModeSelector);
  const {
    isScreenSmOrSmaller
  } = useMediaQueryList();
  const {
    columns: projectTableColumns,
    defaultVisibleColumns: projectTableDefaultVisibleColumns,
    isCompanyContextReady: isProjectTableConfigReady
  } = useProjectTableColumnsConfig();
  const isMapViewMode = viewMode === "map" && !isScreenSmOrSmaller;
  const t2 = !isMapViewMode;
  let t3;
  if ($[1] !== companyId || $[2] !== projectArchivingState || $[3] !== t2) {
    t3 = {
      companyId,
      projectArchivingState,
      isEnabled: t2
    };
    $[1] = companyId;
    $[2] = projectArchivingState;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    projects,
    isFetchingProjects,
    hasFetchedFirstPage,
    nextPageCursor,
    sortBy,
    setSortBy,
    search,
    isDebouncingSearch,
    loadMoreProjects,
    totalCount
  } = useFetchProjects(t3);
  const isLoading = isFetchingProjects && hasFetchedFirstPage || isDebouncingSearch || shouldForceLoading || !hasFetchedFirstPage;
  const shouldShowEmptyPage = !shouldForceLoading && !isFetchingProjects && hasFetchedFirstPage && projects.length === 0;
  const isAnyRowSelected = selectedEntities.length !== 0;
  const shouldRenderActions = projects.length > 0;
  if (isMapViewMode) {
    let t4;
    if ($[5] !== companyId || $[6] !== projectArchivingState || $[7] !== setSortBy || $[8] !== sortBy) {
      t4 = <ProjectsMap companyId={companyId} projectArchivingState={projectArchivingState} sortBy={sortBy} setSortBy={setSortBy} />;
      $[5] = companyId;
      $[6] = projectArchivingState;
      $[7] = setSortBy;
      $[8] = sortBy;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    return t4;
  }
  let t4;
  if ($[10] !== shouldShowEmptyPage) {
    t4 = !shouldShowEmptyPage && <CreateProjectDialog />;
    $[10] = shouldShowEmptyPage;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== setSortBy || $[13] !== shouldRenderActions || $[14] !== sortBy) {
    t5 = shouldRenderActions && <ProjectsSort key="projects-sort" sortBy={sortBy} setSortBy={setSortBy} />;
    $[12] = setSortBy;
    $[13] = shouldRenderActions;
    $[14] = sortBy;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== companyId || $[17] !== isAnyRowSelected || $[18] !== projectArchivingState || $[19] !== projects || $[20] !== selectedEntities || $[21] !== shouldRenderActions || $[22] !== viewMode) {
    t6 = shouldRenderActions && <BulkExportProjects companyId={companyId} selectedProjects={isAnyRowSelected ? selectedEntities : projects} subjectType="workspace" projectStatus={projectArchivingState} areEntitiesSelected={isAnyRowSelected} buttonType="standard" viewMode={viewMode} />;
    $[16] = companyId;
    $[17] = isAnyRowSelected;
    $[18] = projectArchivingState;
    $[19] = projects;
    $[20] = selectedEntities;
    $[21] = shouldRenderActions;
    $[22] = viewMode;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== isLoading || $[25] !== t4 || $[26] !== t5 || $[27] !== t6 || $[28] !== totalCount) {
    t7 = <EntitiesToolbar toolbarEntityName="Project" numberOfRows={totalCount} isLoading={isLoading} mobileAction={t4} sortActions={t5} exportComponent={t6} />;
    $[24] = isLoading;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
    $[28] = totalCount;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  let t8;
  if ($[30] !== projectArchivingState || $[31] !== projects || $[32] !== search || $[33] !== shouldShowEmptyPage) {
    t8 = shouldShowEmptyPage && <><ProjectsOverviewEmptyPage projectArchivingState={projectArchivingState} isSearching={search !== undefined} /><BulkChangeProjectStatus projectStatus={projectArchivingState} projects={projects} /></>;
    $[30] = projectArchivingState;
    $[31] = projects;
    $[32] = search;
    $[33] = shouldShowEmptyPage;
    $[34] = t8;
  } else {
    t8 = $[34];
  }
  let t9;
  if ($[35] !== isLoading || $[36] !== isScreenSmOrSmaller || $[37] !== loadMoreProjects || $[38] !== projectArchivingState || $[39] !== projects || $[40] !== shouldShowEmptyPage || $[41] !== sortBy) {
    t9 = isScreenSmOrSmaller && !shouldShowEmptyPage && <ProjectsMobileView projects={projects} sortBy={sortBy} isLoading={isLoading} projectArchivingState={projectArchivingState} loadMoreProjects={loadMoreProjects} />;
    $[35] = isLoading;
    $[36] = isScreenSmOrSmaller;
    $[37] = loadMoreProjects;
    $[38] = projectArchivingState;
    $[39] = projects;
    $[40] = shouldShowEmptyPage;
    $[41] = sortBy;
    $[42] = t9;
  } else {
    t9 = $[42];
  }
  let t10;
  if ($[43] !== companyId || $[44] !== isLoading || $[45] !== isProjectTableConfigReady || $[46] !== isScreenSmOrSmaller || $[47] !== loadMoreProjects || $[48] !== nextPageCursor || $[49] !== projectArchivingState || $[50] !== projectTableColumns || $[51] !== projectTableDefaultVisibleColumns || $[52] !== projects || $[53] !== setSortBy || $[54] !== shouldShowEmptyPage || $[55] !== sortBy || $[56] !== totalCount || $[57] !== viewMode) {
    t10 = viewMode === "list" && !isScreenSmOrSmaller && !shouldShowEmptyPage && isProjectTableConfigReady && <ColumnPreferencesProvider tableKey="projects-table" columns={projectTableColumns} options={{
      nonConfigurableColumns: ["options"],
      defaultVisibleColumns: projectTableDefaultVisibleColumns
    }}><ProjectsTable projects={projects} companyId={companyId} isLoading={isLoading} nextPageCursor={nextPageCursor} loadMoreProjects={loadMoreProjects} sortBy={sortBy} setSortBy={setSortBy} projectArchivingState={projectArchivingState} totalCount={totalCount} /></ColumnPreferencesProvider>;
    $[43] = companyId;
    $[44] = isLoading;
    $[45] = isProjectTableConfigReady;
    $[46] = isScreenSmOrSmaller;
    $[47] = loadMoreProjects;
    $[48] = nextPageCursor;
    $[49] = projectArchivingState;
    $[50] = projectTableColumns;
    $[51] = projectTableDefaultVisibleColumns;
    $[52] = projects;
    $[53] = setSortBy;
    $[54] = shouldShowEmptyPage;
    $[55] = sortBy;
    $[56] = totalCount;
    $[57] = viewMode;
    $[58] = t10;
  } else {
    t10 = $[58];
  }
  let t11;
  if ($[59] !== companyId || $[60] !== isLoading || $[61] !== isScreenSmOrSmaller || $[62] !== loadMoreProjects || $[63] !== projects || $[64] !== shouldShowEmptyPage || $[65] !== sortBy || $[66] !== viewMode) {
    t11 = viewMode === "cards" && !isScreenSmOrSmaller && !shouldShowEmptyPage && <ProjectsTiles projects={projects} companyId={companyId} isLoading={isLoading} loadMoreProjects={loadMoreProjects} sortBy={sortBy} />;
    $[59] = companyId;
    $[60] = isLoading;
    $[61] = isScreenSmOrSmaller;
    $[62] = loadMoreProjects;
    $[63] = projects;
    $[64] = shouldShowEmptyPage;
    $[65] = sortBy;
    $[66] = viewMode;
    $[67] = t11;
  } else {
    t11 = $[67];
  }
  let t12;
  if ($[68] !== t10 || $[69] !== t11 || $[70] !== t7 || $[71] !== t8 || $[72] !== t9) {
    t12 = <>{t7}{t8}{t9}{t10}{t11}</>;
    $[68] = t10;
    $[69] = t11;
    $[70] = t7;
    $[71] = t8;
    $[72] = t9;
    $[73] = t12;
  } else {
    t12 = $[73];
  }
  return t12;
}